import { useMemo, useRef, useState } from "react"
import MaterialTableWrapper from "../../components/MaterialTableWrapper"
import { dialogTypes } from "../../constants"
import useDepartments from "../../hooks/useDepartments"
import useDialogProps from "../../hooks/useDialogProps"
import useMenu from "../../hooks/useMenu"
import { getLookups } from "../../utils"
import ContractsActionMenu from "./ContractsActionMenu"
import ContractUploadForm from "./ContractUploadForm"
import useContractsActionHandlers from "./useContractsActionHandlers"
import useContractsTableProps from "./useContractsTableProps"
import ContractHistoryDialog from "./ContractHistoryDIalog"

const ContractsPage = ({ isOperator }) => {

    const tableRef = useRef(null)

    const { departments } = useDepartments()
    const departmentLookups = useMemo(() => getLookups(departments, "sname"), [departments])

    const [current, setCurrent] = useState(null)

    const handleMenuOpen = (e, data) => {
        handleDefaultMenuClick(e)
        setCurrent(data)
    }

    const handleClose = () => {
        handleMenuClose()
        setCurrent(null)
    }

    const { dialogData, dialogType, dialogIsOpen } = useDialogProps()
    const uploadFormIsOpen = dialogIsOpen && [dialogTypes.UPLOAD_UNIVERSITY_CONTRACT, dialogTypes.UPLOAD_ENTRANT_CONTRACT].includes(dialogType)
    const historyDialogIsOpen = dialogIsOpen && dialogType === dialogTypes.CONTRACT_HISTORY

    const { anchorEl, open, handleDefaultMenuClick, handleMenuClose } = useMenu()

    const { actionHandlersMap, actionNamesMap, actionsIsLoading, handleCloseDialog, handleOpenHistoryDialog } = useContractsActionHandlers(tableRef, handleClose, current)

    const tableProps = useContractsTableProps(departmentLookups, handleMenuOpen, isOperator)

    return <>
        <MaterialTableWrapper
            tableRef={tableRef}
            {...tableProps}
        />

        <ContractsActionMenu
            currentContract={current}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            actionNamesMap={actionNamesMap}
            actionHandlersMap={actionHandlersMap}
            actionsIsLoading={actionsIsLoading}
            onOpenHistory={handleOpenHistoryDialog}
        />

        <ContractUploadForm
            open={uploadFormIsOpen}
            data={dialogData}
            onSubmit={dialogType === dialogTypes.UPLOAD_UNIVERSITY_CONTRACT ?
                actionHandlersMap.upload_contract_signed_by_university_perform : actionHandlersMap.upload_contract_signed_by_entrant_perform
            }
            onClose={handleCloseDialog}

        />

        <ContractHistoryDialog
            open={historyDialogIsOpen}
            onClose={handleCloseDialog}
            data={current?.history ?? []}
        />
    </>
}

export default ContractsPage